import IndexNotifiq from "@/Pages/Notifiq/IndexNotifiq.vue";

export default [
  {
    path: "/notifiq/presencas",
    name: "notifiq.indexNotifiq",
    title: "Presença Notifiq",
    component: IndexNotifiq,
  },
];
